import { generateOtp, verifyOtp } from '../resolvers/modalOtpUniversia.resolver';
import { handleFormActions } from '../utils/modalOtpUniversia.utils';

const getGenerateOtp = ({ setLoading = () => { }, id, passText, formActions }) => {
    setLoading(true);
    return generateOtp(id)
        .then(res => {
            setLoading(false);
            if (formActions) {
                formActions.change('userProfile.cellPhoneFix', res.body.cellPhone);
            }
        })
        .catch(e => {
            console.error(e);
            passText();
        });
};

const postVerifyOtp = ({ id, userProfile, setShowErrorTexts, setErrorTexts, setErrorCode, formActions, history }) => {

    return verifyOtp({ id, userProfile })
        .then(res => {
            setShowErrorTexts(false);
            const data = res.body;
            handleFormActions(formActions, data);
            history.push({
                pathname: '/hazte-cliente',
            });
        })
        .catch(e => {
            setErrorCode(e);
            if (e.status === 400) {
                setShowErrorTexts(true);
                setErrorTexts({
                    title: 'modalWelcome-expireOtpTitle',
                    description: 'welcomeCard-expireOtpMessage',
                });
                generateOtp(id);
                return;
            }

            if (e.status === 401) {
                setShowErrorTexts(true);
                setErrorTexts({
                    title: 'welcomeCard-errorOtpTitle',
                    description: 'modalWelcome-otpIncorrect',
                });
                return;
            }
            setShowErrorTexts(true);
            setErrorTexts({
                title: 'welcomeCard-errorOtpTitle',
                description: 'welcomeCard-errorOtpMessage',
            });
        });
};

export { getGenerateOtp, postVerifyOtp }